import script from "./TranscodeParamItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./TranscodeParamItem.vue?vue&type=script&lang=ts&setup=true"

import "./TranscodeParamItem.vue?vue&type=style&index=0&id=59bdf281&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59bdf281"]])

export default __exports__